import { useTranslation } from "react-i18next";
import qrcode_insta from "../../../assets/img/qrcode_insta_printbox.png";

const INSTAGRAM_URL = "https://www.instagram.com/printbox_stu/";

function FollowInsta() {
    const { t } = useTranslation();

    return (
        <div className="w-full h-full flex flex-col items-center justify-center gap-[1.6vh] text-center px-[1.6vw]">
            <img
                src={qrcode_insta}
                alt={INSTAGRAM_URL}
                className="w-[12vh] h-[12vh] rounded-[1.6vh] bg-white p-[0.4vh] border-[0.2vh] border-[#E1E4EB]"
            />
            <div className="flex flex-col items-center">
                <span className="text-[2.3vh] font-extrabold tracking-tight">
                    @printbox_stu
                </span>
                <span className="text-[1.4vh] font-semibold text-[#7B8290] mt-[0.4vh]">
                    {t("routeList.social_scan_hint")}
                </span>
            </div>
            <div className="flex gap-[0.8vw]">
                <span className="bg-[#F1F3F7] text-[#7B8290] rounded-full px-[1.4vw] py-[0.5vh] text-[1.15vh] font-bold">
                    Instagram
                </span>
                <span className="bg-[#F1F3F7] text-[#7B8290] rounded-full px-[1.4vw] py-[0.5vh] text-[1.15vh] font-bold">
                    Telegram
                </span>
            </div>
        </div>
    );
}

export default FollowInsta;
